import { t } from '@lingui/macro';

import FormSection from '../../form/FormSection';
import { MAINTENANCE_WINDOW_SITES_COLUMNS, MAINTENANCE_WINDOW_SITES_FIELD } from './MaintenanceWindowsConstants';
import ListSelectorField from '../../form/ListSelectorField';
import { SORT_ASC } from '../../../utilities/FormUtilities';
import { useEntityWithDeviceCountLoader, useMaintenanceWindowFormStyles } from './MaintenanceWindowsUtils';

const initialSort = [{ property: 'name', direction: SORT_ASC }];
const selectionDataSource = {
    totalProperty: 'count',
    dataProperty: 'data',
    params: {
        searchFields: ['name'],
    },
    initialSort,
};

const selectedDataSource = {
    ...selectionDataSource,
    url: '/query/admin/sites/findSelected',
};

const availableDataSource = {
    ...selectionDataSource,
    url: '/query/admin/sites/findAvailable',
};

const idsDataSource = {
    params: selectionDataSource.params,
    url: '/query/admin/sites/selectionUUIDs',
};

export function MaintenanceWindowsSitesSection({ formData, setSitesSelectionDirty, disabled }) {
    const styles = useMaintenanceWindowFormStyles();

    return (
        <FormSection title={t`Maintenance Window Sites`}>
            <div className={styles.selectorWrapper}>
                <ListSelectorField
                    gridColumns={MAINTENANCE_WINDOW_SITES_COLUMNS}
                    sorters={initialSort}
                    dbSelected={formData?.sites?.map((site) => site.id) || []}
                    selectedDataSource={selectedDataSource}
                    selectedLoaderFunction={useEntityWithDeviceCountLoader}
                    availableDataSource={availableDataSource}
                    availableLoaderFunction={useEntityWithDeviceCountLoader}
                    idsDataSource={idsDataSource}
                    fieldName={MAINTENANCE_WINDOW_SITES_FIELD}
                    addButtonText={t`Add Sites`}
                    setSelectionIsDirty={setSitesSelectionDirty}
                    isMultiRemove={false}
                    selectedEmptyGridText={t`There are no Sites in this Maintenance Window`}
                    disabled={disabled}
                />
            </div>
        </FormSection>
    );
}
